import React, { useRef } from 'react';
import { Button as RBButton } from 'react-bootstrap';
import { FaCheckCircle, FaTimesCircle } from 'react-icons/fa';
import { Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';
import { MenuMaster } from "../../../models/config/MenuMaster";
import { MenuMasterForm, MenuMasterFormRefHandle } from "./MenuMasterForm";

export type MenuMasterFormModalProps = {
    title: string;
    isOpen: boolean;
    onClose: () => void;
    disabledKeyField?: boolean;
    defaultValues?: MenuMaster[];
    onSubmit?: (menuMasters: MenuMaster[]) => void;
};

export const MenuMasterFormModal = (props: MenuMasterFormModalProps) => {
    const { disabledKeyField, title, isOpen, onClose, defaultValues, onSubmit } = props;

    const formRef = useRef<MenuMasterFormRefHandle>(null);

    const handleSaveClick = () => {
        const menuMasters = formRef.current?.submit();
        if (!menuMasters) {
            return;
        }

        onSubmit?.(menuMasters);
    };

    return (
        <Modal isOpen={isOpen} toggle={onClose}>
            <ModalHeader toggle={onClose}>{title}</ModalHeader>
            <ModalBody>
                <MenuMasterForm
                    ref={formRef}
                    disabledKeyField={disabledKeyField}
                    defaultValues={defaultValues}
                />
            </ModalBody>
            <ModalFooter>
                <RBButton variant="primary" onClick={handleSaveClick}>
                    <FaCheckCircle /> Save
                </RBButton>
                <RBButton variant="danger" onClick={onClose}>
                    <FaTimesCircle /> Close
                </RBButton>
            </ModalFooter>
        </Modal>
    );
};
